<template>
  <div class="form-field form-date" :rel="name"
       v-bind:class="{'has-suffix': suffix,'form-required': requiredForm, 'form-disabled':isDisabled}">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">
      <div class="form-input-wrapper">
        <i class="icon icon-icon_calendar"></i>
        <datepicker v-model="internalValueTmp" name="uniquename" :format="format" :clear-button="true"
                    clear-button-icon="icon icon-icon_close" :disabled="disabled"></datepicker>
        <!--<input type="text" v-model="dateTime" v-if="dateTime && internalValueTmp"/>-->
        <vue-timepicker v-model="dateTime" :format="formatTime" :minute-interval="15"
                        v-if="dateTime && internalValueTmp && !hideTimeVue" hide-clear-button
                        :disabled="disabled"></vue-timepicker>
        <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'FormField',
  props: ['value', 'label', 'name', 'placeholder', 'suffix', 'format', 'formatTime', 'time', 'required', 'locale', 'hideTime', 'disabled'],
  components: {Datepicker},
  data: function () {
    return {
      utcIsApplied: false,
      internalValue: '',
      internalValueTmp: '',
      dateTime: null,
      localeDate: null,
      hideTimeVue: null,
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.dateTime = this.time;
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.localeDate = this.locale ? this.locale : 'UTC'
    this.hideTimeVue = this.hideTime ? this.hideTime : false
    this.setDisabled(this.disabled)

    this.initDefaultDate();

  },
  methods: {
    initDefaultDate: function () {
      if (this.value) {

        let format = 'YYYY-MM-DD HH:mm:ss'

        if (this.value.length <= 10) {
          format = 'YYYY-MM-DD'
        }

        //console.log('initDefaultDate', this.value + " --> "+format)

        let newDate = this.value ? moment(this.value, format).tz(this.localeDate).format('YYYY-MM-DD HH:mm:ss') : null

        /*
        if( !this.utcIsApplied ){
            if( this.value.length > 10 ){
                newDate = moment(this.value).tz(this.localeDate).format('YYYY.MM.DD HH:mm:ss')
            }else{
                newDate = moment(this.value).tz(this.localeDate).format('YYYY.MM.DD')
            }
            this.utcIsApplied = true;
        }else{
            newDate = this.value
        }*/

        //console.log('initDefaultDate 2', newDate.toString())

        let dateParam = newDate.toString().split(" ")

        this.dateTime = dateParam[1] ? dateParam[1] : this.dateTime

        let date = new Date()
        let current = new Date(dateParam[0])

        this.internalValueTmp = this.formatDate(new Date(current.getTime() - date.getTimezoneOffset() * 60000));
      }
    },
    customFormatter(dateValue) {

      let date = new Date()
      let current = new Date(dateValue)

      if (dateValue) {
        return this.formatDate(new Date(current.getTime() - date.getTimezoneOffset() * 60000));
      }

      return ''

    },
    formatDate: function (date) {

      //console.log('formatDate => ' + date)

      if (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hour = d.getHours(),
            minute = d.getMinutes(),
            second = d.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hour.length < 2) hour = '0' + hour;
        if (minute.length < 2) minute = '0' + minute;
        if (second.length < 2) second = '0' + second;

        //console.log('formatDate return => ' + [year, month, day].join('-'))

        return [year, month, day].join('-')// + ' ' + [hour, minute, second].join(':');
      }

      return ''

    },
    updateInput: function () {
      //console.log('internalValueTmp', this.internalValueTmp)
      if (!this.internalValueTmp) {
        this.dateTime = ''
        this.$emit('input', '');
      } else {
        if (!this.dateTime) {
          this.dateTime = this.time;
        }
        this.$emit('input', this.formatDate(this.internalValueTmp) + (this.dateTime ? ' ' + this.dateTime : ''));
      }
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'dateTime'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.updateInput()
      }
    },
    'internalValueTmp'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.updateInput()
      }
    },
    'value'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.internalValue = newVal;
        this.initDefaultDate();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/Date.vue